import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Dashboard from './views/Dashboards/Dashboard.vue'
import CodingDashboardLanding from './views/Dashboards/CodingDashboardLanding.vue'
import ReviewDashboardLanding from './views/Dashboards/ReviewDashboardLanding.vue'
import Legal from './views/Legal.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import Support from './views/Support.vue'
import NotFound from './views/NotFound.vue'
import store from './store/store'
import { format } from 'date-fns'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // static pages
    { path: '/legal', name: 'legal', component: Legal },
    { path: '/privacy-policy', name: 'privacyPolicy', component: PrivacyPolicy },
    { path: '/support', name: 'support', component: Support },
    { path: '/', name: 'landing', component: Home },
    { path: '/:clientId(\\d+)', name: 'home', component: Home },
    { path: '/:clientId(\\d+)/dashboard/coding', name: 'codingDashboardLanding', meta: { parent: 'codingDashboardLanding' }, component: CodingDashboardLanding },
    { path: '/:clientId(\\d+)/dashboard/review', name: 'reviewDashboardLanding', meta: { parent: 'reviewDashboardLanding' }, component: ReviewDashboardLanding },
    { path: '/:clientId(\\d+)/dashboard', name: 'dashboard', meta: { parent: 'dashboard' }, component: Dashboard },
    // these use code splitting
    { path: '/:clientId(\\d+)/reports', name: 'reports', meta: { parent: 'reports' }, component: () => import(/* webpackChunkName: "coding" */ './views/Reports.vue') },
    // { path: '/:clientId(\\d+)/projects', name: 'reports', component: () => import(/* webpackChunkName: "projects" */ './views/Reports.vue') },
    { path: '/:clientId(\\d+)/my-projects', name: 'my-projects', meta: { parent: 'my-projects' }, component: () => import(/* webpackChunkName: "projects" */ './views/MyProjects/coderProjectList.vue') },
    { path: '/:clientId(\\d+)/my-projects/:id', name: 'my-projects', meta: { parent: 'my-projects' }, component: () => import(/* webpackChunkName: "projects" */ './views/MyProjects/coderProject.vue') },
    { path: '/:clientId(\\d+)/my-projects/inpatient/:drgTableId', meta: { parent: 'my-projects' }, component: () => import(/* webpackChunkName: "projects" */ '@/views/MyProjects/inpatient/coderInpatientReviewPage.vue') },
    // { path: '/:clientId(\\d+)/my-projects/inpatient/worksheet/:drgTableId', component: () => import(/* webpackChunkName: "projects" */ '@/views/MyProjects/inpatient/worksheets/CoderWorksheetsReport.vue') },
    { path: '/:clientId(\\d+)/my-projects/pro/:proRecordId', meta: { parent: 'my-projects' }, component: () => import(/* webpackChunkName: "projects" */ '@/views/MyProjects/pro/coderProReviewPage.vue') },
    // { path: '/:clientId(\\d+)/my-projects/pro/worksheet/:proRecordId', component: () => import(/* webpackChunkName: "projects" */ '@/views/MyProjects/pro/worksheets/CoderWorksheetsReport.vue') },
    { path: '/:clientId(\\d+)/my-projects/outpatient/:ascTableId', meta: { parent: 'my-projects' }, component: () => import(/* webpackChunkName: "projects" */ '@/views/MyProjects/outpatient/coderOutpatientReviewPage.vue') },
    // { path: '/:clientId(\\d+)/my-projects/outpatient/worksheet/:ascTableId', component: () => import(/* webpackChunkName: "projects" */ '@/views/MyProjects/outpatient/worksheets/CoderWorksheetsReport.vue') },
    { path: '/:clientId(\\d+)/requests', name: 'requests', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "group-requests" */ './views/Requests/RequestLists') },
    { path: '/:clientId(\\d+)/requests/coding', name: 'requests-coding', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "group-requests" */ './views/Requests/RequestLists') },
    { path: '/:clientId(\\d+)/requests/review', name: 'requests-review', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "group-requests" */ './views/Requests/RequestLists') },
    { path: '/:clientId(\\d+)/requests/interim', name: 'requests-interim', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "group-requests" */ './views/Requests/RequestLists') },
    { path: '/:clientId(\\d+)/requests/new-coding-request', name: 'codingRequestNew', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "requests" */ './views/Requests/CodingRequestNew') },
    { path: '/:clientId(\\d+)/requests/coding-request/acute/:id', name: 'codingRequestAcute', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "requests" */ './views/Requests/CodingRequestAcute') },
    { path: '/:clientId(\\d+)/requests/coding-request/pro/:id', name: 'codingRequestPro', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "requests" */ './views/Requests/CodingRequestPro') },
    { path: '/:clientId(\\d+)/requests/new-review-request', name: 'reviewRequestNew', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "requests" */ './views/Requests/ReviewRequestNew') },
    { path: '/:clientId(\\d+)/requests/review-request/:id', name: 'reviewRequest', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "requests" */ './views/Requests/ReviewRequest') },
    { path: '/:clientId(\\d+)/requests/new-interim-request', name: 'interimRequestNew', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "requests" */ './views/Requests/InterimRequestNew') },
    { path: '/:clientId(\\d+)/requests/interim-request/:id', name: 'interimRequest', meta: { parent: 'requests' }, component: () => import(/* webpackChunkName: "requests" */ './views/Requests/InterimRequest') },
    { path: '/:clientId(\\d+)/documents', name: 'documents', meta: { parent: 'documents' }, component: () => import(/* webpackChunkName: "documents" */ './views/DocumentManager.vue') },
    { path: '/:clientId(\\d+)/coding-questions', name: 'codingQuestionsList', meta: { parent: 'codingQuestionsList' }, component: () => import(/* webpackChunkName: "codingQuestions" */ './views/CodingQuestions/CodingQuestionsList.vue') },
    { path: '/:clientId(\\d+)/coding-questions/:id', name: 'codingQuestion', meta: { parent: 'codingQuestionsList' }, component: () => import(/* webpackChunkName: "codingQuestions" */ './views/CodingQuestions/CodingQuestion.vue') },
    // user admin
    { path: '/:clientId(\\d+)/user-admin', name: 'userAdminList', meta: { parent: 'userAdminList' }, component: () => import(/* webpackChunkName: "userAdmin" */ './views/UserAdmin/UserAdminList.vue') },
    { path: '/:clientId(\\d+)/user-admin/:id', name: 'userAdmin', meta: { parent: 'userAdminList' }, component: () => import(/* webpackChunkName: "userAdmin" */ './views/UserAdmin/UserAdmin.vue') },
    { path: '*', component: NotFound } // fall back route will show a Page Not Found component
  ]
})

router.beforeEach((to, from, next) => {
  if (to.params.clientId) {
    store.commit('user/SET_CURRENT_CLIENT_BY_ID', parseInt(to.params.clientId))
    next()
  } else {
    store.commit('user/INITIALIZE_CURRENT_CLIENT')
    if (to.name === 'landing') {
      next({ name: 'home', params: { clientId: store.state.user.currentClientId } })
    } else {
      next()
    }
  }

  // check build number on every request
  store
    .dispatch('GET_BUILD_NUMBER')
    .then(response => {
      try {
        if (response.data) {
          if (store.state.buildNumber !== undefined && store.state.buildNumber !== response.data.buildNumber) {
            // set build number and show alert
            store.commit('SET_BUILD_NUMBER', response.data.buildNumber)
            store.commit('SET_SHOW_UPDATE_MESSAGE', true)
            window.buildNumber = response.data.buildNumber
          }
        }
      } catch (e) {}
    })
    .catch(error => {
      console.log(error)
    })

  // check notifications on every request
  let dateRange = []
  let now = new Date()
  dateRange[0] = format(new Date(now.getFullYear(), 0, 1), 'MM-dd-yyyy')
  dateRange[1] = format(new Date(now.getFullYear(), now.getMonth() + 1, 0), 'MM-dd-yyyy')

  let params = {
    startDate: dateRange[0],
    endDate: dateRange[1]
  }
  store.dispatch('notifications/GET_USER_NOTIFICATIONS', params)
})

export default router
